import React from 'react';
import PropTypes from 'prop-types';
import css from './Button.module.scss';

const Button = ({
  children,
  icon,
  iconPosition = 'left',
  variant = 'primary',
  size = 'default',
  disabled = false,
  onClick,
  className = '',
  type = 'button',
  count,
  ...props
}) => {
  const hasContent = children != null;
  const buttonClasses = [
    css.button,
    css[variant],
    css[size],
    disabled ? css.disabled : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled}
      style={{gap: icon && hasContent ? '8px' : '0'}}
      {...props}
    >
      {iconPosition === 'left' && icon && <span className={css.icon}>{icon}</span>}
      {hasContent && <span className={css.content}>{children}</span>}
      {typeof count === 'number' && <span className={css.badge}>{count}</span>}
      {iconPosition === 'right' && icon && <span className={css.icon}>{icon}</span>}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.node,
  iconPosition: PropTypes.oneOf(['left', 'right']),
  variant: PropTypes.oneOf([
    'primary',
    'secondary',
    'tertiary',
    'link',
    'success',
    'warning',
    'danger',
    'ghost'
  ]),
  size: PropTypes.oneOf(['small', 'default']),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  count: PropTypes.number
};

export default Button;
